import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from "@angular/core";
import { ContentHeaderKey } from "src/app/constants/content-header";
import { ChangeRequestFederalTaxModel } from "src/app/models/change-requests";
import { FederalTax } from "src/app/models/taxes";
import { PayrollService } from "src/app/services/payroll.service";
import { PayrollFederalTaxFormComponent } from "./federal-tax-form.component";
import { ChangeRequestStatus } from "src/app/constants/change-request";

@Component({
    selector: 'mwp-federal-tax',
    templateUrl: './federal-tax.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PayrollFederalTaxTableComponent implements OnInit {
    @ViewChild('vcMFTD') childComponent!: PayrollFederalTaxFormComponent;
    public apiUrl = ContentHeaderKey.PayrollFederalTaxDetails;
    public isEditing: boolean = false;
    public hasChangeRequestData: boolean = false;
    public hasRequestedEdit: boolean;
    
    public federalTax: FederalTax;
    public currentChangeRequestFederalTaxModel: ChangeRequestFederalTaxModel;
    public changeRequestFormModel: ChangeRequestFederalTaxModel;

    public pendingOrDeniedHeader: string;
    public buttonText: string;
    public displayTopRequestButton: boolean;
    public displayPendingOrDeniedRequest: boolean;

    constructor(
        private payrollService: PayrollService,
    ) {
    }
    
    ngOnInit(): void {
        this.payrollService.getFederalTaxes().subscribe((response: FederalTax) => {
            this.federalTax = response;
            this.currentChangeRequestFederalTaxModel = response.currentChangeRequestFederalTax;
            this.buildCurrentChangeRequest(response.currentChangeRequestFederalTax??  new ChangeRequestFederalTaxModel());
        });
        this.buttonText = "REQUEST TO CHANGE FEDERAL TAX INFORMATION";
    }

    public newChangeRequest(): void {
        this.changeRequestFormModel = new ChangeRequestFederalTaxModel();
        this.isEditing = !this.isEditing;
    }

    public editChangeRequest(): void {
        this.changeRequestFormModel = this.currentChangeRequestFederalTaxModel;
        this.isEditing = !this.isEditing;
    }

    public cancelEdit(event: ChangeRequestFederalTaxModel): void {
        if (event)
            this.buildCurrentChangeRequest(event);
        this.isEditing = false;
    }

    private buildCurrentChangeRequest(changeRequest: ChangeRequestFederalTaxModel): void {
        this.displayPendingOrDeniedRequest = false;
        this.displayTopRequestButton = true;
        this.pendingOrDeniedHeader = null;
        this.buttonText = "REQUEST TO CHANGE FEDERAL TAX";
        if (changeRequest.id > 0)
            this.currentChangeRequestFederalTaxModel = changeRequest;

        switch(changeRequest.changeRequestStatusID) {
            case ChangeRequestStatus.submitted:
                this.pendingOrDeniedHeader = "Submitted Address Change Request";
                this.buttonText = "UPDATE FEDERAL TAX CHANGE REQUEST"
                this.displayPendingOrDeniedRequest = true;
                break;

            case ChangeRequestStatus.denied:
                this.displayTopRequestButton = false;
                this.pendingOrDeniedHeader = "Denied Federal Tax Change Request";
                this.displayPendingOrDeniedRequest = true;
                break;

            default:
                break;
        }   
    }

}
